(function () {
    'use strict';

    angular
        .module('app.checklists')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
          {
              state: 'checklists',
              config: {
                  abstract: true,
                  url: '/checklists',
                  template: '<ui-view/>',
                  settings: {
                      authMode: 1
                  },
                  resolve: {
                      authenticationRequired: ['userService', function (userService) {
                          userService.isAuthenticatedThrowError();
                      }]
                  }
              }
          },
          {
              state: 'checklists.details',
              config: {
                  url: '/detail/:id',
                  templateUrl: 'app/checklists/details.html?v=' + opsIncludeVersion,
                  controller: 'ChecklistDetailController',
                  controllerAs: 'vm',
                  title: 'Checklist',
                  settings: {},
                  resolve: {
                      isAdmin: ['userService', function (userService) {
                          userService.isAuthenticatedThrowError();
                          if (userService.userType() == "0") {
                              throw { name: "NotAdmin" };
                          }
                      }]
                  }
              }
          },
         {
             state: 'checklists.display',
             config: {
                 url: '/display',
                 templateUrl: 'app/checklists/checklists.html?v=' + opsIncludeVersion,
                 controller: 'ChecklistsController',
                 controllerAs: 'vm',
                 title: 'Checklist',
                 settings: {
                     nav: 500,
                     content: '<i class="fa fa-list"></i> <span class="leftNavText">Information</span>',
                     authMode: 1
                 }
             }
         }
        ];
    }
})();
